import React from "react";
import { useField } from "formik";
import { useDispatch } from "react-redux";

// material
import {
  Container,
  FormControl,
  FormControlLabel,
  MenuItem,
  RadioGroup,
  Radio,
  Typography,
  Stack
} from "@mui/material";

// components
import Page from "../../../components/Page";

// ----------------------------------------------------------------------
import { setUploadFormPostDocPage2 } from "../../../core/redux/action/uploadForm";
import { TextField } from "@material-ui/core";

export default function UploadFormPage1(props) {
  const dispatch = useDispatch();

  const {
    formField: {
      sendingFellowshipReport,
      mainResearchArea,
      researchTitleEnglish,
      progressCommencementFellowship,
      presentProgressResearchProject
    }
  } = props;

  const [sendingFellowshipReportField, sendingFellowshipReportMeta] = useField(
    sendingFellowshipReport
  );
  const [mainResearchAreaField, mainResearchAreaMeta] =
    useField(mainResearchArea);
  const [researchTitleEnglishField, researchTitleEnglishMeta] =
    useField(researchTitleEnglish);
  const [
    progressCommencementFellowshipField,
    progressCommencementFellowshipMeta
  ] = useField(progressCommencementFellowship);
  const [
    presentProgressResearchProjectField,
    presentProgressResearchProjectMeta
  ] = useField(presentProgressResearchProject);

  const choose1 = "6 months progress report";
  const choose2 = "11 months progress report with requesting extension period";
  const choose3 = "11 months progress report (Final report)";
  const choose4 =
    "Progress report for every 3 or 6 month after requesting extension period";
  const choose5 = "Final Progress Report (Before or After 11 months)";

  return (
    <Page title="PART: Grade/Progress/Final Report">
      <Container maxWidth="xl">
        <Stack
          direction="column"
          justifyContent="space-evenly"
          alignItems="stretch"
          spacing={4}
        >
          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {sendingFellowshipReport.label}
            </Typography>
            <RadioGroup
              name={sendingFellowshipReportField.name}
              value={sendingFellowshipReportField.value}
              onChange={(e) => sendingFellowshipReportField.onChange(e)}
            >
              <FormControlLabel
                control={<Radio />}
                label="1. 6 months progress report"
                value="6 months progress report"
              />
              <FormControlLabel
                control={<Radio />}
                label="2. 11 months progress report with requesting extension period"
                value="11 months progress report with requesting extension period"
              />
              <FormControlLabel
                control={<Radio />}
                label="3. 11 months progress report (Final report)"
                value="11 months progress report (Final report)"
              />
              <FormControlLabel
                control={<Radio />}
                label="4. Progress report for every 3 or 6 month after requesting extension period"
                value="Progress report for every 3 or 6 month after requesting extension period"
              />
              <FormControlLabel
                control={<Radio />}
                label="5. Final Progress Report (Before or After 11 months)"
                value="Final Progress Report (Before or After 11 months)"
              />
            </RadioGroup>
            {sendingFellowshipReportMeta.touched && (
              <span
                style={{
                  color: "#FF4842",
                  lineHeight: 1.5,
                  fontSize: "0.75rem",
                  fontFamily: "sans-serif",
                  fontWeight: 400,
                  textAlign: "left",
                  marginTop: "3px",
                  marginRight: "14px",
                  marginBottom: 0,
                  marginLeft: "14px"
                }}
              >
                {sendingFellowshipReportMeta.error}
              </span>
            )}
          </FormControl>

          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {mainResearchArea.label}
            </Typography>
            <TextField
              variant="outlined"
              name={mainResearchAreaField.name}
              value={mainResearchAreaField.value}
              onChange={(e) => mainResearchAreaField.onChange(e)}
              error={Boolean(
                mainResearchAreaMeta.touched && mainResearchAreaMeta.error
              )}
              helperText={
                mainResearchAreaMeta.touched && mainResearchAreaMeta.error
              }
            />
          </FormControl>

          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {researchTitleEnglish.label}
            </Typography>
            <TextField
              variant="outlined"
              name={researchTitleEnglishField.name}
              value={researchTitleEnglishField.value}
              onChange={(e) => researchTitleEnglishField.onChange(e)}
              error={Boolean(
                researchTitleEnglishMeta.touched &&
                  researchTitleEnglishMeta.error
              )}
              helperText={
                researchTitleEnglishMeta.touched &&
                researchTitleEnglishMeta.error
              }
            />
          </FormControl>

          <FormControl fullWidth>
            <Typography variant="subtitle2">
              {progressCommencementFellowship.label}
            </Typography>
            <TextField
              select
              variant="outlined"
              name={progressCommencementFellowshipField.name}
              value={progressCommencementFellowshipField.value}
              onChange={(e) => progressCommencementFellowshipField.onChange(e)}
              error={Boolean(
                progressCommencementFellowshipMeta.touched &&
                  progressCommencementFellowshipMeta.error
              )}
              helperText={
                progressCommencementFellowshipMeta.touched &&
                progressCommencementFellowshipMeta.error
              }
            >
              <MenuItem value={"Less than 50%"}>Less than 50%</MenuItem>
              <MenuItem value={"60%"}>60%</MenuItem>
              <MenuItem value={"70%"}>70%</MenuItem>
              <MenuItem value={"80%"}>80%</MenuItem>
              <MenuItem value={"90%"}>90%</MenuItem>
              <MenuItem value={"Complete"}>Complete</MenuItem>
            </TextField>
          </FormControl>

          <FormControl
            fullWidth
            disabled={sendingFellowshipReportField?.value ? false : true}
          >
            <Typography variant="subtitle2">
              {sendingFellowshipReport.label}
            </Typography>
            <RadioGroup
              name={presentProgressResearchProjectField.name}
              value={presentProgressResearchProjectField.value}
              onChange={(e) => {
                presentProgressResearchProjectField.onChange(e);
                dispatch(setUploadFormPostDocPage2(e.target.value));
              }}
            >
              <FormControlLabel
                control={<Radio />}
                label="Section A: Before paper submission"
                value="section_a"
                disabled={
                  sendingFellowshipReportField?.value !== choose1 &&
                  sendingFellowshipReportField?.value !== choose2 &&
                  sendingFellowshipReportField?.value !== choose4
                    ? true
                    : false
                }
              />
              <FormControlLabel
                control={<Radio />}
                label="Section B: Paper submission"
                value="section_b"
                disabled={
                  sendingFellowshipReportField?.value !== choose1 &&
                  sendingFellowshipReportField?.value !== choose2 &&
                  sendingFellowshipReportField?.value !== choose4
                    ? true
                    : false
                }
              />
              <FormControlLabel
                control={<Radio />}
                label="Section C: Being accepted for Publication"
                value="section_c"
                disabled={
                  sendingFellowshipReportField?.value !== choose1 &&
                  sendingFellowshipReportField?.value !== choose3 &&
                  sendingFellowshipReportField?.value !== choose5
                    ? true
                    : false
                }
              />
              <FormControlLabel
                control={<Radio />}
                label="Section D: Published available"
                value="section_d"
                disabled={
                  sendingFellowshipReportField?.value !== choose1 &&
                  sendingFellowshipReportField?.value !== choose3 &&
                  sendingFellowshipReportField?.value !== choose5
                    ? true
                    : false
                }
              />
            </RadioGroup>
            {presentProgressResearchProjectMeta.touched && (
              <span
                style={{
                  color: "#FF4842",
                  lineHeight: 1.5,
                  fontSize: "0.75rem",
                  fontFamily: "sans-serif",
                  fontWeight: 400,
                  textAlign: "left",
                  marginTop: "3px",
                  marginRight: "14px",
                  marginBottom: 0,
                  marginLeft: "14px"
                }}
              >
                {presentProgressResearchProjectMeta.error}
              </span>
            )}
          </FormControl>
        </Stack>
      </Container>
    </Page>
  );
}
